<template>
  <Object3D @element="setupBase">
    <!-- <Brick @element="(v) => { setupObj3D(v, br, i); }" :brick="br" v-for="(br, i) in root.bricks" :key="br.numID" :color="br.color">
    </Brick> -->
    <!-- <BrickInstance :camera="engine.camera" :root="root"></BrickInstance> -->

    <Portal v-if="doQuitz && currentClicked" @uiportal="(v) => { $emit('uiportal', v) }">
      <quitz :activeTiles="activeTiles" :room="room"  :root="root" :players="players" :currentClicked="currentClicked" :myInfo="myInfo" @show="(v) => { doQuitz = v }" @correct="(v) => { v ? onRightAns() : onWrongAns() }"></quitz>
    </Portal>

    <BrickPoints @hover="(v) => { hover = v }" :cleaner="cleaner" :deadCells="deadCells" :deadAround="deadAround" :myInfo="myInfo" :highlightTiles="highlightTiles" v-if="toucher && base && activeTiles" :activeTiles="activeTiles" :base="base" @geometry-ready="onGeoReady" @click-brick="onClickBrick" :players="players" :toucher="toucher" :engine="engine" :camera="engine.camera" :root="root"></BrickPoints>
  </Object3D>
</template>

<script>
// import Box from '../vfx/Items/Box.vue'
// import BoxBufferGeometry from '../vfx/Geometry/BoxBufferGeometry.vue'
// import SphereBufferGeometry from '../vfx/Geometry/SphereBufferGeometry.vue'
// import PlaneBufferGeometry from '../vfx/Geometry/PlaneBufferGeometry.vue'
// import Mesh from '../vfx/Items/Mesh.vue'
// import Points from '../vfx/Items/Points.vue'
// import SolidMaterial from '../vfx/Material/SolidMaterial.vue'
// import AudioNormalMaterial from '../vfx/Material/AudioNormalMaterial.vue'
// import DevMaterial from '../vfx/Material/DevMaterial.vue'
// import { setInterval } from 'timers'
// import * as THREE from 'three'

import './setimmediate.js'
import FreeJS from '../vfx/FreeJS'
import * as Game from '../game/game.js'
import _ from 'lodash'
import Portal from '../game/Portal.vue'
import SimulationEngine from 'worker-loader!../game/SimulationEngine.js';
import { setTimeout, setInterval, clearInterval } from 'timers';
import { State } from '../game/auth.js'
var TWEEN = require('@tweenjs/tween.js')

export default {
  props: {
    myInfo: {
      require: true
    },
    players: {
      require: true
    },
    visible: {
      default: false
    },
    engine: {
      required: true
    },
    root: {
      required: true
    },
    room: {
      required: true
    },
    toucher: {
    }
  },
  components: {
    Portal,
    // Brick,
    ...FreeJS,
    // Brick: require('../game/Brick.vue').default,
    // BrickInstance: require('../game/BrickInstance.vue').default
    quitz: require('../game/quitz/quitz.vue').default,
    BrickPoints: require('../game/BrickPoints.vue').default
    // DevMaterial,
    // SolidMaterial,
    // AudioNormalMaterial,
    // Points,
    // BoxBufferGeometry,
    // SphereBufferGeometry,
    // Box
  },
  data () {
    return {
      showHover: false,
      hover: false,
      currentClicked: false,
      cleaner: [],
      deadAround: [],
      deadCells: [],
      chosenBrick: {},
      doQuitz: false,
      highlightTiles: [],
      highlightClickers: [],
      activeTiles: [],
      attributes: false,
      intersects: [],
      clickables: [],
      base: false,
      // size: { x: 30, y: 30, z: 1 },
      // sizePlusPad: 32,
      Math,
      left: false,
      geo: {
        plane: false,
        box: false,
        sphere: false
      },
      mat: {
        audio: false
      }
    }
  },
  watch: {
    hover () {
      if (this.hover) {
        let item = (this.activeTiles || []).find(a => a.numID === this.hover.numID)
        if (item) {
          this.showHover = item.belongsTo
        } else {
          this.showHover = false
        }
        this.$emit('showHover', this.showHover)
      } else {
        this.$emit('showHover', false)
      }
      // console.log(this.intersects)
    },
    base () {
      if (this.base) {
        this.base.visible = this.visible
      }
    },
    visible () {
      if (this.base) {
        this.base.visible = this.visible
      }
    }
  },
  created () {
    this.$on('add', (v) => {
      this.$parent.$emit('add', v)
    })
    this.$on('remove', (v) => {
      this.$parent.$emit('remove', v)
    })
    this.$on('my-cells-are-dead', (deadCells) => {
      Game.removeDeadCells({ deadCells, gameID: this.myInfo.gameID })
    })
  },
  beforeDestroy () {
    this.left = true
  },
  mounted () {
    window.addEventListener('keyup', (evt) => {
      if (evt.keyCode + '' === '27') {
        this.doQuitz = false
        this.$forceUpdate()
      }
    })
    this.$on('find-myself', () => {
      this.locateMyself()
    })
    this.$on('find-player', ({ player }) => {
      this.locatePlayer({ player })
    })
    this.$emit('add-exec', () => {
      if (this.left) {
        return
      }
      TWEEN.update()
    })

    this.simulateThings()

    // if (this.mat.audio) {
    //   setInterval(() => {
    //     if (this.mat.audio && this.mat.audio.uniforms.audioTexture) {
    //       this.mat.audio.uniforms.audioTexture.value = this.audioAPI.texture
    //     }
    //   }, 1000 / 60)
    // }
  },
  methods: {
    onCultureReady () {
      Game.onTilesArrive({
        gameID: this.myInfo.gameID,
        myInfo: this.myInfo,
        onArrive: (tiles) => {
          this.refresher(tiles)
        },
        onCellCoreDestroy: (userID) => {
          console.log('userID..........')
          if (userID) {
            let killer = this.players.find(p => p.userID === userID)
            if (killer) {
              this.$emit('gameover', {
                killer: killer,
                cb: () => {
                  // Game.joinGame({ root: this.root, gameID: this.room.roomID })
                  //   .then((myInfo) => {
                  //     this.$emit('gameover', false)
                  //     this.$emit('myInfo', myInfo)
                  //     this.$parent.findPlayer({ player: myInfo })
                  //     this.$nextTick(() => {
                  //       this.highlightTiles = []
                  //       this.refresher(this.activeTiles)
                  //     })
                  //   })

                  window.location.assign(`/game-play/${encodeURIComponent(this.myInfo.gameID)}`)
                }
              })
              // Game.cleanUp({ gameID: this.myInfo.gameID, player: this.myInfo })
              //   .then(() => {
              //   })
            }
          }
        }
      })
    },
    // onHighlightArrive ({ duration, highlightTiles }) {
    //   this.highlightTiles = highlightTiles
    //   this.$forceUpdate()
    // },

    refresher (tiles) {
      this.activeTiles = tiles.filter(t => !t.dead)
      let deadTiles = tiles.filter(t => t.dead)
      this.deadCells = deadTiles
      this.cleaner = this.root.bricks.slice()
      this.deadAround = this.getCornerTiles(deadTiles)

      this.highlightTiles = this.goHighlightTiles(this.activeTiles)
      this.highlightClickers = this.highlightTiles.slice()
      this.$forceUpdate()

      this.goCheckCellCoreDead()
      this.goCheckcutOff()

      this.$emit('activeTiles', this.activeTiles)
    },
    goCheckCellCoreDead () {
      // console.log(this.myInfo)
      let activeCellCore = this.activeTiles.find(a => a.numID === this.myInfo.gameInfo.cellCore.numID)
      if (activeCellCore) {
        // cell core captured
        if (activeCellCore.belongsTo !== this.myInfo.userID) {
          // FDB.ref(`/players/${gameID}/players/${this.myInfo.userID}`).remove()
        }
      }
    },
    simulateThings () {
      this.simson = new SimulationEngine()
      this.simson.onmessage = (evt) => {
        let signal = evt.data
        this[signal.type](signal.args)
      }
      this.simson.postMessage({
        type: 'runMakeCulture',
        args: {
          xmax: this.root.xnum,
          ymax: this.root.ynum
        }
      })
    },
    goCheckcutOff () {
      let map = this.root.xymap
      let activeMap = {}
      let getActive = (item) => {
        if (!item) {
          return false
        }
        return activeMap[item.xid + '-' + item.yid]
      }

      // sync to map
      this.activeTiles.forEach((active) => {
        active.hasEnergy = false
        activeMap[active.xid + '-' + active.yid] = active
      })

      let getAround = (cell, userID) => !cell ? [] : [
        activeMap[(cell.xid + 0) + '-' + (cell.yid + 1)],
        activeMap[(cell.xid + 0) + '-' + (cell.yid - 1)],
        activeMap[(cell.xid + 1) + '-' + (cell.yid + 0)],
        activeMap[(cell.xid - 1) + '-' + (cell.yid + 0)],

        // activeMap[(cell.xid + 1) + '-' + (cell.yid + 1)],
        // activeMap[(cell.xid - 1) + '-' + (cell.yid - 1)],
        // activeMap[(cell.xid + 1) + '-' + (cell.yid - 1)],
        // activeMap[(cell.xid - 1) + '-' + (cell.yid + 1)]
      ].filter(e => !!e && e.belongsTo === userID)

      let energise = (items) => {
        items.forEach((item) => {
          let target = getActive(item)
          if (target) {
            target.hasEnergy = true
          }
        })
      }

      const timeoutPromise = (timeout) => new Promise((resolve) => setTimeout(resolve, timeout));
      const immediatePromise = (timeout) => new Promise((resolve) => window.setImmediate(resolve));

      let canGoNextStep = async (items, userID, player) => {
        let expanded = []
        // only add when the item dont have
        let weakset = new WeakSet()

        // items = items.filter((t) => {
        //   return t.belongsTo === userID
        // })

        let start = window.performance.now()
        for (var kn in items) {
          let proc = window.performance.now() - start
          // time slice performance optimistaion
          // let the browser to do some rendering
          if (proc > 50) {
            start = window.performance.now()
            await immediatePromise(0)
          }

          let ii = items[kn]
          getAround(ii, userID).forEach((item) => {
            if (!weakset.has(item)) {
              expanded.push(item)
              weakset.add(item)
            }
          })
          // expanded = [...expanded, ...getAround(ii)]
        }

        // items.forEach(async (ii) => {
        // })

        expanded = expanded.filter((t) => {
          return t.belongsTo === userID
        })

        expanded = expanded.filter((t) => {
          return !getActive(t).hasEnergy
        })

        return {
          expanded,
          canGoFurther: expanded.length > 0
        }
      }

      let totalDeadcells = []
      let resolve = (userID, player) => {
        // let deadCells = []
        let energised = this.activeTiles.filter(a => a.belongsTo === userID).filter((t) => {
          return getActive(t) && getActive(t).hasEnergy
        })
        let left = this.activeTiles.filter(a => a.belongsTo === userID).filter((t) => {
          return getActive(t) && !getActive(t).hasEnergy
        })

        // deadCells.push(...left)
        totalDeadcells.push(...left)

        player.doneClean = true

        console.log('user', userID, 'energised cell',energised.length, 'dead cell', left.length)
        if (this.players.filter(p => p.doneClean).length === this.players.length) {
          this.$emit('my-cells-are-dead', totalDeadcells)
        }
      }

      window.requestIdleCallback =
        window.requestIdleCallback ||
        function (cb) {
          var start = Date.now();
          return setTimeout(function () {
            cb({
              didTimeout: false,
              timeRemaining: function () {
                return Math.max(0, 50 - (Date.now() - start));
              }
            });
          }, 1);
        }

      window.cancelIdleCallback =
        window.cancelIdleCallback ||
        function (id) {
          clearTimeout(id);
        }

      let popagate = async (hand, userID, player) => {
        let { expanded, canGoFurther } = await canGoNextStep(hand, userID, player)
        if (canGoFurther) {
          hand = expanded
          energise(hand)
          await timeoutPromise(1)
          popagate(hand, userID, player)
        } else {
          resolve(userID, player)
        }
      }



      let users = _.groupBy(this.activeTiles, 'belongsTo')
      console.log(users)
      this.players.forEach(p => {
        p.doneClean = false
      })
      this.players.forEach((player) => {
        setTimeout(() => {
          let cellCore = player.gameInfo.cellCore
          let userID = player.userID
          let myCore = getActive(cellCore)

          energise([myCore], userID, player)
          popagate([myCore], userID, player)
        }, 10)
      })
    },
    getCornerTiles (scope) {
      let map = this.root.xymap
      let info = scope.filter(a => a.belongsTo === this.myInfo.userID).reduce((info, tile) => {
        let found = [
          map[(tile.xid + 0) + '-' + (tile.yid + 1)],
          map[(tile.xid + 0) + '-' + (tile.yid - 1)],
          map[(tile.xid + 1) + '-' + (tile.yid + 0)],
          map[(tile.xid - 1) + '-' + (tile.yid + 0)],

          // map[(tile.xid + 1) + '-' + (tile.yid + 1)],
          // map[(tile.xid - 1) + '-' + (tile.yid - 1)],
          // map[(tile.xid + 1) + '-' + (tile.yid - 1)],
          // map[(tile.xid - 1) + '-' + (tile.yid + 1)]
        ].filter(e => e)
        info.bucket.push(...found)
        return info
      }, {
        xymap: this.root.xymap,
        bucket: []
      })
      info.bucket = _.uniqBy(info.bucket.slice(), 'numID')
      info.bucket = info.bucket.filter((t) => {
        return !this.activeTiles.some(a => a.numID === t.numID && a.belongsTo === this.myInfo.userID)
      })
      return info.bucket
    },
    goHighlightTiles (scope) {
      let map = this.root.xymap
      let info = scope.filter(a => a.belongsTo === this.myInfo.userID).reduce((info, tile) => {
        let found = [
          map[(tile.xid + 0) + '-' + (tile.yid + 1)],
          map[(tile.xid + 0) + '-' + (tile.yid - 1)],
          map[(tile.xid + 1) + '-' + (tile.yid + 0)],
          map[(tile.xid - 1) + '-' + (tile.yid + 0)],

          // map[(tile.xid + 1) + '-' + (tile.yid + 1)],
          // map[(tile.xid - 1) + '-' + (tile.yid - 1)],
          // map[(tile.xid + 1) + '-' + (tile.yid - 1)],
          // map[(tile.xid - 1) + '-' + (tile.yid + 1)],
        ].filter(e => e)
        info.bucket.push(...found)
        return info
      }, {
        xymap: this.root.xymap,
        bucket: []
      })
      info.bucket = _.uniqBy(info.bucket.slice(), 'numID')
      info.bucket = info.bucket.filter((t) => {
        return !this.activeTiles.some(a => a.numID === t.numID && a.belongsTo === this.myInfo.userID)
      })
      return info.bucket
    },
    locatePlayer ({ player, zLevel = 2000 }) {
      let numID = player.gameInfo.cellCore.numID
      let stride = this.stridesMap[numID]

      let x = this.geometry.attributes.position.array[stride * 3 + 0]
      let y = this.geometry.attributes.position.array[stride * 3 + 1]
      // let z = this.geometry.attributes.position.array[stride * 3 + 2]

      let coord = { ...this.engine.camera.position }
      setTimeout(() => {
        if (this.t1) {
          this.t1.stop()
        }
        if (this.t2) {
          this.t2.stop()
        }
        this.t1 = new TWEEN.Tween(coord)
          .to({ x, y, z: zLevel }, 2000)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate(() => {
            this.engine.control.target0.x = coord.x
            this.engine.control.target0.y = coord.y
            this.engine.control.target0.z = 0
            this.engine.control.position0.x = coord.x
            this.engine.control.position0.y = coord.y
            this.engine.control.position0.z = coord.z
            this.engine.control.reset()
          })
        this.t2 = new TWEEN.Tween(coord)
          .to({ x, y, z: window.innerWidth > 500 ? 200 : 100 }, 1000)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate(() => {
            this.engine.control.target0.x = coord.x
            this.engine.control.target0.y = coord.y
            this.engine.control.target0.z = 0
            this.engine.control.position0.x = coord.x
            this.engine.control.position0.y = coord.y
            this.engine.control.position0.z = coord.z
            this.engine.control.reset()
          })

        this.t1.chain(this.t2)
        this.t1.start()
      }, 1)
      // console.log(x, y, z)
    },
    locateMyself () {
      this.locatePlayer({ player: this.myInfo, zLevel: 2000 })
    },
    onGeoReady ({ geometry, stridesMap }) {
      this.stridesMap = stridesMap
      this.geometry = geometry

      this.locateMyself()
    },
    onClickBrick ({ numID, xid, yid, brick }) {
      this.chosenBrick = { numID, xid, yid, brick }
      // if (window.cleanAndClear === true && process.env.NODE_ENV === 'development') {
      //   let cell = this.activeTiles.find(e => e.numID === numID)
      //   let gameID = this.myInfo.gameID
      //   console.log('-------CLEAR---------')
      //   console.log(JSON.stringify(cell, null, '  '))
      //   if (window.confirm(`clear?`)) {
      //     cell.hasEnergy = false
      //     cell.toBeRemoved = true
      //     Game.adminResetCell({ gameID, cell })
      //   }
      //   return
      // }

      if (this.highlightClickers.some(e => e.numID === numID)) {
        // console.log('can click')

        console.log(process.env.NODE_ENV)

        if (window.debugCapture && process.env.NODE_ENV === 'development') {
          this.onRightAns()
          return
        }

        // resotre
        this.currentClicked = {
          brick,
          numID
        }

        this.doQuitz = true
        this.$forceUpdate()

        // debug
        // this.onRightAns()
      } else {
        // console.log('cannot click')
      }
    },
    onRightAns () {
      let { numID, xid, yid, brick } = this.chosenBrick
      let myColor = this.myInfo.myColor
      let gameID = this.myInfo.gameID

      // brick.belongsTo = State.user.uid
      // brick.color = myColor

      // let analysed = this.goCheckcutOff()
      // console.log(analysed)
      //

      Game.setTileToMineProperly({ root: this.root, gameID, numID, tile: brick, myColor, players: this.players, activeTiles: this.activeTiles })
    },
    onWrongAns () {
      // Game.setTileToMineProperly({ gameID: this.myInfo.gameID, numID, tile: brick, myColor: this.myInfo.myColor })
    },
    setupBase (base) {
      base.visible = this.visible
      this.$emit('element', base)
      this.base = base
    }
    // setupObj3D (oBrick, br, i) {
    //   // console.log(oBrick)
    //   let pos = this.getPos(br)
    //   oBrick.userData = oBrick.userData || {}
    //   oBrick.userData.brick = br

    //   oBrick.position.x = pos.x
    //   oBrick.position.y = pos.y
    //   oBrick.position.z = pos.z
    //   oBrick.updateMatrix()
    //   oBrick.matrixAutoUpdate = false
    //   this.clickables.push(oBrick)
    // },
    // getPos (br) {
    //   let { sizePlusPad, root } = this
    //   return {
    //     x: br.xid * sizePlusPad - (root.xnum - 1) * sizePlusPad * 0.5, y: br.yid * sizePlusPad - (root.ynum - 1) * sizePlusPad * 0.5, z: 0
    //   }
    // }
  }
}
</script>

<style scoped>

</style>
